import { useEffect, useRef, useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";
import OverviewTab from '../../components/crm/OverviewTab';
import StatsTab from '../../components/crm/StatsTab';
import TaskManager from '../../components/crm/TaskManager';
import apiService from "../../services/apiService";
import {
  LeadResponse,
  RMList
} from "../../utils/interfaces";
import { getLocalStorageItem } from "../../utils/Validation";
import { Lead as CRMLead } from '../../types/crm';
import { BarChart3, LayoutGrid, UsersRound } from "lucide-react";

interface LeadListResponse {
  data: LeadResponse[];
  total: number;
}

interface RMListResponse {
  data: RMList[];
}

const mapApiLeadToCRMLead = (apiLead: any): CRMLead => ({
  id: apiLead.lm_id,
  companyName: apiLead.companyName,
  designation: apiLead.designation || '',
  name: apiLead.name,
  mobile: apiLead.phone || '',
  phone: apiLead.phone || '',
  email: apiLead.email || '',
  leadType: apiLead.leadType || '',
  leadSource: apiLead.leadSource || '',
  leadRM: (apiLead.rmFirstName || '') + ' ' + (apiLead.rmLastName || ''),
  totalCalls: apiLead.totalCalls || 0,
  nextFollowUp: apiLead.nextFollowUp || '',
  leadStatusId: apiLead.leadStatusId || '',
  createdAt: apiLead.lm_createdAt || '',
  lastCallDate: apiLead.lastCallDate || '',
  interactions: Array.isArray(apiLead.interactions) ? apiLead.interactions : [],
  score: apiLead.score || 0,
  priority: apiLead.priority || 'Medium',
  industry: apiLead.industry || '',
  companySize: apiLead.companySize || '',
  budget: apiLead.budget || 0,
  territory: apiLead.territory || '',
  tags: apiLead.tags || [],
  lastActivityDate: apiLead.lastActivityDate || '',
  estimatedCloseDate: apiLead.estimatedCloseDate || '',
  dealValue: apiLead.dealValue || 0,
  tasks: apiLead.tasks || [],
  notes: apiLead.notes || [],
  rmleadId: apiLead.userId,
  location:apiLead.location
});

const CRM = () => {
  const hasFetched = useRef(false);
  const [userPermissions, setUserPermissions] = useState<any>(null);
  const [leadData, setLeadData] = useState<CRMLead[]>([]);
  const [total, setTotal] = useState<number>(0);
  const [uniqueRmNames, setUniqueRmNames] = useState<RMList[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [leadLocation,setLeadLocation] = useState<any[]>([])
  const [loading, setLoading] = useState(false);
  const [showOverView, setShowOverView] = useState(false);

  const [activeFilters, setActiveFilters] = useState({
    search: '',
    status: [],
    userId: '',
    createdAtFrom: '',
    createdAtTo: '',
    updatedAtFrom: '',
    updatedAtTo: '',
    scheduledAtFrom: '',
    scheduledAtTo: '',
    filterview: 'all',
    location:[]
  });

  const handleUpdateTasks = (leadId: number, tasks: any[]) => {

  };



  useEffect(() => {
    getUserRole();
    if (hasFetched.current) return;
    hasFetched.current = true;
    getRMListData();
    fetchUserDetails();
    fetchLeadLocation();


  }, []);

  const getUserRole = async () => {
    const userDetails = getLocalStorageItem("detail");
    const userId = userDetails?.userId;
    const response: any = await apiService.get(`/users/${userId}`);
    if (response.role.role_name == 'Super Admin' || response.role.role_name == 'super admin') {
      setShowOverView(true)
    } else {
      setShowOverView(false)
    }
  }



  const getRMListData = async () => {
    try {
      const response: RMListResponse = await apiService.get("/users/rm-list");
      setUniqueRmNames(response.data);
    } catch (e) {
    }
  };

  useEffect(() => {
    if (userPermissions) {
      getLeadListData(currentPage, pageSize);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userPermissions, currentPage, pageSize, activeFilters]);

  const onPageChange = (page: number, pageSize: number) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const getLeadListData = async (
  page = 1,
  pageSize = 50,
  filters = activeFilters // <--- use here
) => {

    setLoading(true);
    let userFromDetail = "";
    // const userData = localStorage.getItem("detail");
  

    // if (userData) {
    //   try {
    //     const parsedData = JSON.parse(userData);
    //     if (parsedData?.userId) {
    //       userFromDetail = parsedData.userId.toString();
    //     }
    //   } catch (error) {
    //     console.error("Error parsing user data from localStorage:", error);
    //   }
    // }

    try {
      const response: LeadListResponse = await apiService.post("/leads/list", {
        pageSize,
        page,
        search: filters.search,
        status: filters.status,
        createdAtTo: filters.createdAtTo,
        createdAtFrom: filters.createdAtFrom,
        updatedAtFrom: filters.updatedAtFrom,
        updatedAtTo: filters.updatedAtTo,
        scheduledAtFrom: filters.scheduledAtFrom,
        scheduledAtTo: filters.scheduledAtTo,
        rmUserId: filters.userId,
        filterview: filters.filterview,
        location:filters.location
      });

      let filteredData = response.data;
      // if (userPermissions?.manage_lead?.view === "assigned") {
      //   filteredData = response.data.filter(
      //     (lead: any) =>
      //       String(lead.userId) == String(userFromDetail) || lead.createdBy == userFromDetail
      //   );
      // }
      const crmLeads = filteredData.map(mapApiLeadToCRMLead);
      setLeadData(crmLeads);
      setTotal(response.total);
    } catch (e) {
    } finally {
      setLoading(false);
    }
  };

  const fetchUserDetails = async () => {
    try {
      const userDataStr = getLocalStorageItem("detail");
      if (userDataStr) {
        const userData =
          typeof userDataStr === "string"
            ? JSON.parse(userDataStr)
            : userDataStr;
        const userId = userData?.userId;
        if (userId) {
          const response: any = await apiService.get(`/users/${userId}`);
          setUserPermissions(response.role.permissions);
        }
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const fetchLeadLocation = async () => {
    try {
          const response: any = await apiService.get(`/leads/getLeadLocation`);
          // setUserPermissions(response.role.permissions);
          setLeadLocation(response.data);
        }
      
    catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const filterLead = (viewId: any) => {
    setActiveFilters({
      search: '',         // clear search
      status: [],         // clear status filter
      userId: '',         // clear userId filter
      createdAtFrom: '',  // clear date filters
      createdAtTo: '',
      updatedAtFrom: '',
      updatedAtTo: '',
      scheduledAtFrom: '',
      scheduledAtTo: '',
      filterview: viewId , // set only the selected filterview
      location:[]
    });
    setCurrentPage(1);  // reset to first page
    setPageSize(50);    // optionally reset page size to default if you want
  };

  const handleapplyfilter = (filter:any) => {
    setActiveFilters({
      ...activeFilters,
      // map your filter object accordingly
      filterview:"all",
      userId: filter.leadRM || '',
      createdAtFrom: filter.createdDateFrom || '',
      createdAtTo: filter.createdDateTo || '',
      updatedAtFrom: filter.lastCallDateFrom || '',
      updatedAtTo: filter.lastCallDateTo || '',
      status: filter.status || '',
      location:filter.location || []
    });
    setCurrentPage(1); // reset to page 1
  };

  

  const handleTodayCalls = () => {
    const now = new Date();
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999);
  
    const scheduledAtFrom = formatLocalDate(startOfDay);
    const scheduledAtTo = formatLocalDate(endOfDay);
  
    setActiveFilters(prev => ({
      ...prev,
      scheduledAtFrom,
      scheduledAtTo
      // (keep other filters intact, unless you want to clear them)
    }));
    setCurrentPage(1); // always reset page when applying filter
  };

  function formatLocalDate(date: Date): string {
    return date.getFullYear() + '-' +
      String(date.getMonth() + 1).padStart(2, '0') + '-' +
      String(date.getDate()).padStart(2, '0') + ' ' +
      String(date.getHours()).padStart(2, '0') + ':' +
      String(date.getMinutes()).padStart(2, '0') + ':' +
      String(date.getSeconds()).padStart(2, '0');
  }


  const [searchTerm, setSearchTerm] = useState('');

  const handleSearch = (term:any) => {
    setActiveFilters(prev => ({
      ...prev,
      search: term
    }));
    setCurrentPage(1);
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      handleSearch(searchTerm);
    }, 500);
    return () => clearTimeout(delayDebounce);
  }, [searchTerm]);

  const handleUpdateLead = (updatedLead: CRMLead) => {
    setLeadData(prevLeads =>
      prevLeads.map(lead =>
        lead.id === updatedLead.id
          ? { ...lead, ...updatedLead }
          : lead
      )
    );
  };
  const handleDeleteLead = (id: number) => {
    setLeadData(prevLeads =>
      prevLeads.filter(lead => lead.id !== id)
    );
  };

  return (
    <div className="min-h-screen w-full bg-[#f7f8fb]">
      <div className="max-w-[1920px] mx-auto  pb-2.5 border-t border-l">
      
          <Tabs defaultValue="overview" className="w-full">
            <header className="shrink-0 w-full bg-white/95 backdrop-blur-md border-b border-slate-200">
              <div className="max-w-[1920px] mx-auto px-5 py-2.5">
                <div className="relative flex flex-col gap-4 xl:flex-row xl:items-center">
  
  {/* Left Fixed Section */}
  <div className="flex items-center gap-2.5 xl:min-w-[260px]">
    <div className="p-2 bg-[#eef7f8] rounded-2xl">
      <UsersRound className="h-4 w-4 text-[#5da8b4]" />
    </div>
    <div>
      <h1 className="text-[20px] leading-none font-semibold text-slate-800 tracking-tight">
        Lead Management
      </h1>
      <p className="mt-1 text-[11px] text-slate-500">
        Track, manage & convert your leads
      </p>
    </div>
  </div>

  {/* Center Tabs */}
  {showOverView && (
  <div className="xl:absolute xl:left-1/2 xl:-translate-x-1/2">
    <TabsList className="inline-flex h-auto w-fit items-center rounded-2xl border border-slate-200 bg-slate-50/90 p-1 shadow-[0_8px_30px_rgba(15,23,42,0.05)]">
      <TabsTrigger
        value="overview"
        className="group relative inline-flex min-w-[134px] items-center justify-center gap-2 rounded-xl px-3.5 py-2 text-[13px] font-medium text-slate-500 data-[state=active]:bg-white data-[state=active]:text-slate-900 data-[state=active]:shadow-sm data-[state=active]:ring-1 data-[state=active]:ring-[#5da8b4]/15"
      >
        <span className="flex h-5 w-5 items-center justify-center rounded-md bg-white text-slate-400 transition-colors group-data-[state=active]:bg-[#e7f6f8] group-data-[state=active]:text-[#4d9aa6]">
          <LayoutGrid className="h-3 w-3" />
        </span>
        <span>Overview</span>
      </TabsTrigger>

      <TabsTrigger
        value="stats"
        className="group relative inline-flex min-w-[110px] items-center justify-center gap-2 rounded-xl px-3.5 py-2 text-[13px] font-medium text-slate-500 data-[state=active]:bg-white data-[state=active]:text-slate-900 data-[state=active]:shadow-sm data-[state=active]:ring-1 data-[state=active]:ring-[#5da8b4]/15"
      >
        <span className="flex h-5 w-5 items-center justify-center rounded-md bg-white text-slate-400 transition-colors group-data-[state=active]:bg-[#e7f6f8] group-data-[state=active]:text-[#4d9aa6]">
          <BarChart3 className="h-3 w-3" />
        </span>
        <span>Stats</span>
      </TabsTrigger>
    </TabsList>
  </div>
)}
</div>
              </div>
            </header>

            <TabsContent value="overview" className="mt-3 space-y-3.5 px-5">
                <OverviewTab
                  todayCalls={handleTodayCalls}
                  leads={leadData}
                  total={total}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  onPageChange={onPageChange}
                  loading={loading}
                  rmList={uniqueRmNames}
                  onLeadAdded={() => getLeadListData(currentPage, pageSize)}
                  filterLead={filterLead}
                  applyfilter={handleapplyfilter}
                  onSearchChange={setSearchTerm}
                  searchTerm={searchTerm}
                  onUpdateLeadsdata={handleUpdateLead}
                  onDeleteLeads={handleDeleteLead}
                  leadLocation={leadLocation}
                />
            </TabsContent>

            <TabsContent value="tasks" className="mt-3 space-y-3.5">
              <TaskManager leads={leadData} onUpdateTasks={handleUpdateTasks} />
            </TabsContent>

            <TabsContent value="stats" className="mt-3 space-y-3.5">
              <StatsTab />
            </TabsContent>
          </Tabs>
      </div>
    </div>
  );
};

export default CRM;
